<template>
    <div class="stepSevenRoot">
      <div class="circleItem"><CircleVue currentIndex="7"></CircleVue> </div>
      <div class="backPageItem"><BackPageVue  @backPreviewPage="hanldGoBack"></BackPageVue> </div>

        <div>
            <div class="titleLine">Please leave your email</div>
            <div class="subTitle">We’ll analyze your responses (takes about 30 seconds). If you’re short on time, we’ll also send the results directly to your inbox.</div>

        </div>
      
        <div class="emailLine">
          <el-input v-model="inputEmali" placeholder="Please leave your email" @blur="inputBlur"></el-input>
        </div>

      <div class="btnLine">
          <div class="disBtn" v-if="!emaliStatus">Quick Analysis</div>
          <div class="chooseBtn" v-else @click="goToNextStep(8)">Quick Analysis</div>
      </div>

      <!-- <div class="anaLine" @click="goToNextStep(8)">Try a quick analysis first</div> -->

      <!-- <div class="LastLine">
            <div class="skipBtn"  @click="goToNextStep(8)">Try a quick analysis first</div>
      </div> -->
      <div class="LastLine2">
          <div class="oneItem">©  2012-2026 PaperSpotlight. All rights reserved.</div>
          <!-- <div class="twoItem">The data presented is based on our independent research and analysis. While we strive for accuracy, results may vary across different fields and contexts. Unauthorized reproduction or distribution of this content is prohibited.</div> -->
      </div>
    </div>
</template>
<script>
import CircleVue from './circle.vue'
import BackPageVue from './backPage.vue'
import moment from 'moment';


export default {
    components:{CircleVue,BackPageVue},
    data(){
      return{
        imgObj:{
          guideHomebg1:require("../../assets/img/main/guideHomebg1.png"),
          guideHomebg2:require("../../assets/img/main/guideHomebg2.png"),
        },
       
        inputEmali:'',
        emaliStatus:false,

      }
  },
  mounted: function() {
    let userData = JSON.parse(localStorage.getItem('userData'))
    if(userData&&userData.stepSeven){
      this.inputEmali = userData&&userData.stepSeven
    }
    if( this.inputEmali){
      this.inputBlur()

    }
  },
  methods:{
    inputBlur(){
      console.log(this.inputEmali)
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.inputEmali) {
        this.emaliStatus = false
        this.$message.error('The email address cannot be empty!');
      } else if (!emailRegex.test(this.inputEmali)) {
        this.emaliStatus = false
        this.$message.error('Please enter a legitimate email address!');
      } else {
        this.emaliStatus = true

      }
    },
    hanldGoBack(){
      localStorage.setItem('guideIndex', 6);
      this.$emit('changePage', 6);
    },
    goToRegister(){
      let userData = JSON.parse(localStorage.getItem('userData'))
      userData.weight = this.getWeight(userData)
      if(this.inputEmali){
        userData.stepSeven = this.inputEmali
        let str = JSON.stringify(userData)
        localStorage.setItem('userData', str);

      }else{
        userData.stepSeven = ''
        let str = JSON.stringify( userData)
        localStorage.setItem('userData', str);
      }

      let param={
        email:this.inputEmali,
        body: JSON.stringify(userData)
      }
      this.$https('potentialEmail',param).then(res => {
              
            }).catch(err=>{
            })

      // this.$emit('changePage', 20);
      // if(this.$route.path !== '/resetPassword'){
      //   this.$router.push('/resetPassword'); // 如果使用了路径
      // }
    },
    goToNextStep(){
      localStorage.setItem('guideIndex', 8);

      let userData = JSON.parse(localStorage.getItem('userData'))
      let arr = this.getWeight(userData)
      console.log('this.getWeight(userData)',arr)
      userData.weight = [...arr]
      if(this.inputEmali){
        userData.stepSeven = this.inputEmali
        let str = JSON.stringify(userData)
        localStorage.setItem('userData', str);

      }else{
        userData.stepSeven = ''
        let str = JSON.stringify( userData)
        localStorage.setItem('userData', str);
      }
      this.goToRegister()
      this.$emit('changePage', 8);

    },
    getWeight(item){
      let  defaultWeight=[
        [3,2,1,2],
        [1,1,5,1],
        [1,1,4,2],
        [2,2,2,2],
        [3,3,1,1],
        [2,2,2,2],

      ]
      console.log('item1',item)
      let weight = []
      let one = parseInt(item.stepOne)
      if(one>=0){
        one = one-1
        weight = [...defaultWeight[one]]
      }else{
        weight = [2,2,2,2]
      }
      let year = item.stepFive.length ? parseInt(item.stepFive[0]):''
      // 目标年份
      year = parseInt(year) ; 
      // 获取当前年份
      const currentYear = moment().year(); // 或 new Date().getFullYear()
      // 计算差值（绝对值，避免负数）
      const yearsDiff = Math.abs(currentYear - year);
      console.log('weight1',weight,year,yearsDiff)

      if(0<=yearsDiff && yearsDiff<=1){ 
        weight[0] =  weight[0]+1
        weight[1] =  weight[1]-1
        weight[2] =  weight[2]+1
        weight[3] =  weight[3]-1
      }else if(yearsDiff>=3){
        weight[0] =  weight[0]-1
        weight[1] =  weight[1]-1
        weight[2] =  weight[2]+2
      }
      console.log('weight2',weight)

      let currentCitation = item.stepSix.length ?item.stepSix[0]:''
      if(0<currentCitation && currentCitation<=2){
        weight[0] =  weight[0]-1
        weight[1] =  weight[1]-1
        weight[2] =  weight[2]+1
        weight[3] =  weight[3]+1
      }else if(currentCitation>2 &&currentCitation<5){
        console.log(22,currentCitation)

        weight[0] =  weight[0]+1
        weight[1] =  weight[1]+1
        weight[2] =  weight[2]-1
        weight[3] =  weight[3]-1
      }else if(currentCitation>=5){
        console.log(3333,currentCitation)
        weight[0] =  weight[0]+2
        weight[1] =  weight[1]+1
        weight[2] =  weight[2]-1
        weight[3] =  weight[3]-2
      }
      console.log('weight3',weight,currentCitation)

      let muchMOnth = item.stepSix.length ?item.stepSix[2]:''
      if(0<muchMOnth && muchMOnth<7){
        weight[0] =  weight[0]-1
        weight[1] =  weight[1]-2
        weight[2] =  weight[2]+2
        weight[3] =  weight[3]+1
      }else if(muchMOnth>=7 && muchMOnth<=11){
        weight[0] =  weight[0]
        weight[1] =  weight[1]-1
        weight[2] =  weight[2]+1
        weight[3] =  weight[3]
      }
      console.log('weight5',weight,muchMOnth)

        while(Math.min(...weight)<0){
          let minNum = Math.min(...weight)
          let maxNum = Math.max(...weight)
          const minIndex = weight.indexOf(minNum);
          const maxIndex = weight.indexOf(maxNum); // 找到最大值的索引
          weight[minIndex] =  weight[minIndex] +1
          weight[maxIndex] =  weight[maxIndex] -1

        }
      console.log('weight5',weight)

        return weight

    }
  }
}
</script>
<style  lang="scss">
 .chooseItem .el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered{
            margin-left: 0 !important;
        }
         .el-checkbox{
            margin-right: 0 !important;
        } 
        .el-checkbox.is-bordered.is-checked{
            border-color: #feae00 !important;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner{
            border-color: #feae00 !important;
              background: #feae00 !important;
        }
        .el-checkbox__input.is-checked+.el-checkbox__label{
            color: #feae00 !important;
        }
        .el-checkbox.is-bordered.el-checkbox--small{
            width: 100%;
            display: flex;
            align-items: center;
            padding:12px 20px !important;
            border: none !important;
            height:auto !important;
        }
        .el-checkbox.is-bordered.el-checkbox--small .el-checkbox__label{
            padding-left: 20px !important;
          color: #000;
          font-size: 16px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: normal !important;
        }
        .el-checkbox__inner:hover{
            border-color: #feae00 !important;
        }
</style>
<style lang="scss">
.stepSevenRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 0 30px 0;
    gap: 50px;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 100px;
      top:40px;
      width: 30px;
      height: 30px;
    }
    .circleItem{
      position: absolute;
      right: 100px;
      top:40px;
      width: 50px;
      height: 50px;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 600px;
        color: var(---2, #333);
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .emailLine{
      width: 500px;
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .anaLine{
      margin-top: -30px;
      cursor: pointer;
      color: var(---3, #999);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 150% */
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
      text-transform: capitalize;
    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -50px;
      .skipBtn{
          cursor: pointer;
          padding: 12px 40px;
            font-size: 16px;
            color: #999;
        }
      }
    .LastLine2{
      flex: 1 1;
      display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -20px;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
@media screen and (max-width:767px) { 
  .stepSevenRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20vw 6vw 10vw 6vw;
    gap: 6vw;
    position: relative;
  .backPageItem{
      position: absolute;
      left: 2vw;
      top:3vw;
      width: 4vw;
      height: 4vw;
    }
  .circleItem{
      position: absolute;
      right: 2vw;
      top:3vw;
      width: 8vw;
      height: 8vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-size: 6vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 600px;
        color: var(---2, #333);
        text-align: center;
        font-size: 3.4vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .emailLine{
      width: 80%;
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .anaLine{
      margin-top: 3vw;
      cursor: pointer;
      color: var(---3, #999);
      text-align: center;
      font-size: 3.4vw;
      font-style: normal;
      font-weight: 400;
      line-height: 1.5; /* 150% */
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
      text-transform: capitalize;
    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -6vw;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 3.4vw;
            color: #999;
        }
      }
      .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -4vw;
        .oneItem{
            color: var(---1, #000);
            text-align: center;
            font-size: 3.4vw;
            font-style: normal;
            font-weight: 400;
            line-height: 1.3; /* 110% */
          }
          .twoItem{
            width: 90%;
            max-width: 900px;
            color: #aaa;
            text-align: center;
            font-size: 3vw;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
    }
}
}


@media screen  and (min-width: 767px) and (max-width: 1200px){
  .stepSevenRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 6vw 0 3vw 0;
  gap: 5vw;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .circleItem{
      position: absolute;
      right: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-size: 3.2vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 600px;
        color: var(---2, #333);
        text-align: center;
        font-size: 1.6vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .emailLine{
      width: 50vw;
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .anaLine{
      margin-top: 1vw;
      cursor: pointer;
      color: var(---3, #999);
      text-align: center;
      font-size: 1.6vw;
      font-style: normal;
      font-weight: 400;
      line-height: 1.5; /* 150% */
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
      text-transform: capitalize;
    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -5vw;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 1.6vw; 
            color: #999;
        }
      }
      .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -1vw;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 1.6vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.3; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;

          text-align: center;
          font-size: 1.2vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
}
</style>